var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsEnum, IsNotEmpty, IsOptional, IsString, IsDate, IsBoolean, ValidateIf, IsEmpty, IsNumber } from 'class-validator';
import { merge as deepMerge } from 'lodash';
import { compareTimes, dateToString, parseTime, stringToDate, timeToUiString } from '@/utils/dates';
import { ModelDto } from './model';
export var PostVisibility;
(function (PostVisibility) {
    PostVisibility[PostVisibility["PLATFORM_ONLY"] = 1] = "PLATFORM_ONLY";
    PostVisibility[PostVisibility["PLATFORM_AND_SURROUNDING"] = 2] = "PLATFORM_AND_SURROUNDING";
    PostVisibility[PostVisibility["PUBLIC"] = 3] = "PUBLIC";
    PostVisibility[PostVisibility["GROUP"] = 4] = "GROUP";
})(PostVisibility || (PostVisibility = {}));
export var PlatformPostVisibility;
(function (PlatformPostVisibility) {
    PlatformPostVisibility[PlatformPostVisibility["PLATFORM_ONLY"] = 1] = "PLATFORM_ONLY";
    PlatformPostVisibility[PlatformPostVisibility["PLATFORM_AND_SURROUNDING"] = 2] = "PLATFORM_AND_SURROUNDING";
    PlatformPostVisibility[PlatformPostVisibility["PUBLIC"] = 3] = "PUBLIC";
})(PlatformPostVisibility || (PlatformPostVisibility = {}));
export var GroupPostVisibility;
(function (GroupPostVisibility) {
    GroupPostVisibility[GroupPostVisibility["GROUP"] = 4] = "GROUP";
    GroupPostVisibility[GroupPostVisibility["PUBLIC"] = 3] = "PUBLIC";
})(GroupPostVisibility || (GroupPostVisibility = {}));
export var PostableType;
(function (PostableType) {
    PostableType["NEWS"] = "news";
    PostableType["NEIGHBOURHOOD_AID"] = "neighbourhood_aid";
    PostableType["EVENT"] = "event";
    PostableType["DOCUMENT"] = "document";
    PostableType["MARKETPLACE"] = "marketplace";
    PostableType["SURVEY"] = "survey";
})(PostableType || (PostableType = {}));
export var SpaceableType;
(function (SpaceableType) {
    SpaceableType["PLATFORM"] = "platform";
    SpaceableType["GROUP"] = "group";
})(SpaceableType || (SpaceableType = {}));
export var SurveyChoiceType;
(function (SurveyChoiceType) {
    SurveyChoiceType[SurveyChoiceType["SINGLE"] = 1] = "SINGLE";
    SurveyChoiceType[SurveyChoiceType["MULTIPLE"] = 2] = "MULTIPLE";
})(SurveyChoiceType || (SurveyChoiceType = {}));
export var NeighbourhoodAidType;
(function (NeighbourhoodAidType) {
    NeighbourhoodAidType[NeighbourhoodAidType["SEARCH"] = 1] = "SEARCH";
    NeighbourhoodAidType[NeighbourhoodAidType["OFFER"] = 2] = "OFFER";
    NeighbourhoodAidType[NeighbourhoodAidType["ANONYMOUS_SEARCH"] = 3] = "ANONYMOUS_SEARCH";
})(NeighbourhoodAidType || (NeighbourhoodAidType = {}));
export var MarketplaceType;
(function (MarketplaceType) {
    MarketplaceType[MarketplaceType["SEARCH"] = 1] = "SEARCH";
    MarketplaceType[MarketplaceType["OFFER"] = 2] = "OFFER";
    MarketplaceType[MarketplaceType["BORROW"] = 3] = "BORROW";
    MarketplaceType[MarketplaceType["FREE"] = 4] = "FREE";
})(MarketplaceType || (MarketplaceType = {}));
export var MarketplacePriceType;
(function (MarketplacePriceType) {
    MarketplacePriceType[MarketplacePriceType["FIXED_PRICE"] = 1] = "FIXED_PRICE";
    MarketplacePriceType[MarketplacePriceType["NEGOTIABLE"] = 2] = "NEGOTIABLE";
})(MarketplacePriceType || (MarketplacePriceType = {}));
export var EventAccessStatus;
(function (EventAccessStatus) {
    EventAccessStatus[EventAccessStatus["PUBLIC"] = 1] = "PUBLIC";
    EventAccessStatus[EventAccessStatus["PRIVATE"] = 2] = "PRIVATE";
})(EventAccessStatus || (EventAccessStatus = {}));
export var EventOccurrence;
(function (EventOccurrence) {
    EventOccurrence["NONE"] = "none";
    EventOccurrence["DAILY"] = "daily";
    EventOccurrence["WEEKLY"] = "weekly";
    EventOccurrence["MONTHLY"] = "monthly";
    EventOccurrence["YEARLY"] = "yearly";
})(EventOccurrence || (EventOccurrence = {}));
export var EventResponseStatus;
(function (EventResponseStatus) {
    EventResponseStatus[EventResponseStatus["NONE"] = 0] = "NONE";
    EventResponseStatus[EventResponseStatus["ACCEPT"] = 1] = "ACCEPT";
    EventResponseStatus[EventResponseStatus["MAYBE"] = 2] = "MAYBE";
    EventResponseStatus[EventResponseStatus["DECLINE"] = 3] = "DECLINE";
})(EventResponseStatus || (EventResponseStatus = {}));
export var EventApplicationStatus;
(function (EventApplicationStatus) {
    EventApplicationStatus[EventApplicationStatus["PENDING"] = 1] = "PENDING";
    EventApplicationStatus[EventApplicationStatus["APPROVED"] = 2] = "APPROVED";
    EventApplicationStatus[EventApplicationStatus["DECLINED"] = 3] = "DECLINED";
})(EventApplicationStatus || (EventApplicationStatus = {}));
export var MarketplacePillFilters;
(function (MarketplacePillFilters) {
    MarketplacePillFilters[MarketplacePillFilters["OVERVIEW"] = 1] = "OVERVIEW";
    MarketplacePillFilters[MarketplacePillFilters["MY_POSTS"] = 2] = "MY_POSTS";
    MarketplacePillFilters[MarketplacePillFilters["INTERESTED_IN_POSTS"] = 3] = "INTERESTED_IN_POSTS";
})(MarketplacePillFilters || (MarketplacePillFilters = {}));
export var NeighbourHoodAidPillFilters;
(function (NeighbourHoodAidPillFilters) {
    NeighbourHoodAidPillFilters[NeighbourHoodAidPillFilters["OVERVIEW"] = 1] = "OVERVIEW";
    NeighbourHoodAidPillFilters[NeighbourHoodAidPillFilters["MY_POSTS"] = 2] = "MY_POSTS";
    NeighbourHoodAidPillFilters[NeighbourHoodAidPillFilters["INTERESTED_IN_POSTS"] = 3] = "INTERESTED_IN_POSTS";
})(NeighbourHoodAidPillFilters || (NeighbourHoodAidPillFilters = {}));
export var DocumentPillFilters;
(function (DocumentPillFilters) {
    DocumentPillFilters[DocumentPillFilters["OVERVIEW"] = 1] = "OVERVIEW";
    DocumentPillFilters[DocumentPillFilters["MY_POSTS"] = 2] = "MY_POSTS";
})(DocumentPillFilters || (DocumentPillFilters = {}));
export var SurveyPillFilters;
(function (SurveyPillFilters) {
    SurveyPillFilters[SurveyPillFilters["OVERVIEW"] = 1] = "OVERVIEW";
    SurveyPillFilters[SurveyPillFilters["MY_POSTS"] = 2] = "MY_POSTS";
    SurveyPillFilters[SurveyPillFilters["ALREADY_PARTICIPATED"] = 4] = "ALREADY_PARTICIPATED";
})(SurveyPillFilters || (SurveyPillFilters = {}));
export var EventPillFilters;
(function (EventPillFilters) {
    EventPillFilters[EventPillFilters["OVERVIEW"] = 1] = "OVERVIEW";
    EventPillFilters[EventPillFilters["MY_POSTS"] = 2] = "MY_POSTS";
    EventPillFilters[EventPillFilters["CONFIRMED_ATTENDANCE"] = 5] = "CONFIRMED_ATTENDANCE";
})(EventPillFilters || (EventPillFilters = {}));
export var NeighbourhoodAidDropdownFilters;
(function (NeighbourhoodAidDropdownFilters) {
    NeighbourhoodAidDropdownFilters["ALL"] = "all";
    NeighbourhoodAidDropdownFilters["SEARCH"] = "search";
    NeighbourhoodAidDropdownFilters["OFFER"] = "offer";
})(NeighbourhoodAidDropdownFilters || (NeighbourhoodAidDropdownFilters = {}));
export var ToggleFilters;
(function (ToggleFilters) {
    ToggleFilters[ToggleFilters["MY_POSTS"] = 1] = "MY_POSTS";
    ToggleFilters[ToggleFilters["PRIVATE_POSTS"] = 2] = "PRIVATE_POSTS";
    ToggleFilters[ToggleFilters["ACTIVE_POSTS"] = 3] = "ACTIVE_POSTS";
    ToggleFilters[ToggleFilters["NEIGHBOURHOOD_ONLY_POSTS"] = 4] = "NEIGHBOURHOOD_ONLY_POSTS";
})(ToggleFilters || (ToggleFilters = {}));
export var ActivityStreamFilters;
(function (ActivityStreamFilters) {
    ActivityStreamFilters[ActivityStreamFilters["OVERVIEW"] = 1] = "OVERVIEW";
    ActivityStreamFilters[ActivityStreamFilters["NEIGHBOURHOOD"] = 2] = "NEIGHBOURHOOD";
    ActivityStreamFilters[ActivityStreamFilters["COMMUNITY"] = 3] = "COMMUNITY";
    ActivityStreamFilters[ActivityStreamFilters["MEMBERSHIP"] = 4] = "MEMBERSHIP";
})(ActivityStreamFilters || (ActivityStreamFilters = {}));
export var GroupFilters;
(function (GroupFilters) {
    GroupFilters[GroupFilters["COMMUNITY_GROUPS"] = 1] = "COMMUNITY_GROUPS";
})(GroupFilters || (GroupFilters = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["RECEIVE_EVENT_INVITATION_NOTIFICATION"] = "receive_event_invitation_notification";
    NotificationType["NEW_EVENT_PARTICIPANT_NOTIFICATION"] = "new_event_participant_notification";
    NotificationType["NEW_SURROUNDING_NOTIFICATION"] = "new_surrounding_notification";
    NotificationType["NEW_SURVEY_PARTICIPANT_NOTIFICATION"] = "new_survey_participant_notification";
    NotificationType["NEW_COMMENT_NOTIFICATION"] = "new_comment_notification";
    NotificationType["EVENT_RESPONSE_NOTIFICATION"] = "event_response_notification";
    NotificationType["NEW_INTEREST_ON_NEIGHBOUR_HOOD_AID_NOTIFICATION"] = "new_interest_on_neighbour_hood_aid_notification";
    NotificationType["GROUP_SUBSCRIPTION_ADMIN_NOTIFICATION"] = "group_subscription_admin_notification";
    NotificationType["CLOSED_GROUP_JOIN_REQUEST_TO_ADMIN_NOTIFICATION"] = "closed_group_join_request_to_admin_notification";
    NotificationType["PUBLIC_GROUP_JOIN_TO_ADMIN_NOTIFICATION"] = "public_group_join_to_admin_notification";
    NotificationType["EVENT_INVITATION_CANCEL_NOTIFICATION"] = "event_invitation_cancel_notification";
    NotificationType["ATTACH_GROUPS_TO_NEIGHBOURHOODS_NOTIFICATION"] = "attach_groups_to_neighbourhoods_notification";
    NotificationType["USER_JOINED_GROUP_BY_EMAIL_TO_ADMIN_NOTIFICATION"] = "user_joined_group_by_email_to_admin_notification";
    NotificationType["GROUP_INVITATION_NOTIFICATION"] = "group_invitation_notification";
    NotificationType["NEW_LIKE_NOTIFICATION"] = "new_like_notification";
    NotificationType["ATTACH_GROUPS_TO_COMMUNITY_NOTIFICATION"] = "attach_groups_to_community_notification";
    NotificationType["JOIN_GROUP_REQUEST_APPROVED_TO_USER_NOTIFICATION"] = "join_group_request_approved_to_user_notification";
})(NotificationType || (NotificationType = {}));
var PostDto = /** @class */ (function (_super) {
    __extends(PostDto, _super);
    function PostDto(postableType, post) {
        var _a, _b;
        var _this = _super.call(this, post) || this;
        _this.originalPost = post;
        if (post) {
            _this.title = post.title;
            _this.message = post.postable.message;
            _this.visibilityStatus = post.visibility_status;
            _this.postableId = post.postable_id;
            _this.postableType = post.postable_type;
            _this.spaceableId = post.spaceable_id;
            _this.spaceableType = post.spaceable_type;
            _this.onBehalfOf = post.on_behalf_of;
            _this.activateComment = post.activate_comment === 1;
            _this.attachments = (_b = (_a = post.attachments) === null || _a === void 0 ? void 0 : _a.map(function (attachment) { return attachment.id; })) !== null && _b !== void 0 ? _b : [];
        }
        else {
            _this.postableType = postableType;
            _this.attachments = [];
            _this.visibilityStatus = PostVisibility.PLATFORM_ONLY;
        }
        return _this;
    }
    PostDto.prototype.setAttachments = function (attachments) {
        this.attachments = attachments.map(function (attachment) { return attachment.id; });
    };
    PostDto.prototype.toRestModel = function () {
        var model = _super.prototype.toRestModel.call(this);
        model.title = this.title;
        model.visibility_status = this.visibilityStatus;
        model.postable_id = this.postableId;
        model.postable_type = this.postableType;
        model.spaceable_id = this.spaceableId;
        model.spaceable_type = this.spaceableType;
        model.on_behalf_of = this.onBehalfOf;
        model.activate_comment = this.activateComment ? 1 : 0;
        model.attachments = this.attachments;
        return model;
    };
    PostDto.prototype.toGqlModel = function (merge) {
        var _a;
        var model = _super.prototype.toGqlModel.call(this, merge);
        model.title = this.title;
        model.visibility_status = this.visibilityStatus;
        model.spaceable_id = this.spaceableId;
        model.spaceable_type = this.spaceableType;
        model.postable_id = this.postableId;
        model.postable_type = this.postableType;
        model.on_behalf_of = this.onBehalfOf;
        model.activate_comment = this.activateComment ? 1 : 0;
        model.comments = { paginatorInfo: { currentPage: 0, hasMorePages: false, perPage: 2, total: 0 }, data: [] };
        if (this.message) {
            model.postable = {
                message: this.message,
            };
        }
        if ((_a = this.originalPost) === null || _a === void 0 ? void 0 : _a.author) {
            model.author = this.originalPost.author;
        }
        return deepMerge(model, merge);
    };
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", String)
    ], PostDto.prototype, "title", void 0);
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", String)
    ], PostDto.prototype, "message", void 0);
    __decorate([
        IsEnum(PostVisibility),
        __metadata("design:type", Number)
    ], PostDto.prototype, "visibilityStatus", void 0);
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", String)
    ], PostDto.prototype, "spaceableId", void 0);
    __decorate([
        IsEnum(SpaceableType),
        __metadata("design:type", String)
    ], PostDto.prototype, "spaceableType", void 0);
    __decorate([
        IsOptional(),
        __metadata("design:type", String)
    ], PostDto.prototype, "onBehalfOf", void 0);
    __decorate([
        IsBoolean(),
        IsOptional(),
        __metadata("design:type", Boolean)
    ], PostDto.prototype, "activateComment", void 0);
    __decorate([
        IsArray(),
        IsOptional(),
        __metadata("design:type", Array)
    ], PostDto.prototype, "attachments", void 0);
    __decorate([
        IsOptional(),
        __metadata("design:type", String)
    ], PostDto.prototype, "postableId", void 0);
    __decorate([
        IsEnum(PostableType),
        __metadata("design:type", String)
    ], PostDto.prototype, "postableType", void 0);
    return PostDto;
}(ModelDto));
export { PostDto };
var SurveyPostDto = /** @class */ (function (_super) {
    __extends(SurveyPostDto, _super);
    function SurveyPostDto(survey) {
        var _this = _super.call(this, PostableType.SURVEY, survey) || this;
        if (survey) {
            _this.message = survey.postable.message;
            _this.choiceType = survey.postable.choice_type;
            _this.choices = survey.postable.survey_choices.map(function (_a) {
                var choice = _a.choice;
                return choice;
            });
            _this.anonymous = survey.postable.anonymous === 1;
            if (survey.postable.end_date) {
                _this.endDate = stringToDate(survey.postable.end_date);
            }
        }
        else {
            _this.choiceType = SurveyChoiceType.SINGLE;
            _this.anonymous = false;
            _this.choices = [];
        }
        return _this;
    }
    SurveyPostDto.prototype.toRestModel = function () {
        var model = _super.prototype.toRestModel.call(this);
        model.message = this.message;
        model.choice_type = this.choiceType;
        model.choices = this.choices;
        model.anonymous = this.anonymous ? 1 : 0;
        if (this.endDate) {
            model.end_date = dateToString(this.endDate, { resetTime: true });
        }
        return model;
    };
    SurveyPostDto.prototype.toGqlModel = function (merge) {
        var model = _super.prototype.toGqlModel.call(this, merge);
        model.postable = {
            message: this.message,
            choice_type: this.choiceType,
            anonymous: this.anonymous ? 1 : 0,
            total_participants: 0,
            survey_choices: this.choices.map(function (choice, i) { return ({ id: i.toString(), choice: choice, total_participants: 0 }); }),
        };
        return deepMerge(model, merge);
    };
    __decorate([
        IsEnum(SurveyChoiceType),
        __metadata("design:type", Number)
    ], SurveyPostDto.prototype, "choiceType", void 0);
    __decorate([
        IsNotEmpty(),
        IsString({ each: true }),
        __metadata("design:type", Array)
    ], SurveyPostDto.prototype, "choices", void 0);
    __decorate([
        IsDate(),
        IsOptional(),
        __metadata("design:type", Date)
    ], SurveyPostDto.prototype, "endDate", void 0);
    __decorate([
        IsBoolean(),
        IsOptional(),
        __metadata("design:type", Boolean)
    ], SurveyPostDto.prototype, "anonymous", void 0);
    return SurveyPostDto;
}(PostDto));
export { SurveyPostDto };
var NewsPostDto = /** @class */ (function (_super) {
    __extends(NewsPostDto, _super);
    function NewsPostDto(post) {
        var _this = _super.call(this, PostableType.NEWS, post) || this;
        if (post) {
            _this.message = post.postable.message;
        }
        return _this;
    }
    NewsPostDto.prototype.toRestModel = function () {
        var model = _super.prototype.toRestModel.call(this);
        model.message = this.message;
        return model;
    };
    NewsPostDto.prototype.toGqlModel = function (merge) {
        var model = _super.prototype.toGqlModel.call(this, merge);
        model.postable = {
            message: this.message,
        };
        return deepMerge(model, merge);
    };
    return NewsPostDto;
}(PostDto));
export { NewsPostDto };
var NeighbourhoodAidDto = /** @class */ (function (_super) {
    __extends(NeighbourhoodAidDto, _super);
    function NeighbourhoodAidDto(post) {
        var _this = _super.call(this, PostableType.NEIGHBOURHOOD_AID, post) || this;
        if (post) {
            _this.message = post.postable.message;
            _this.type = post.postable.type;
            _this.asap = post.postable.asap;
            if (post.postable.expire_at) {
                _this.expireAt = stringToDate(post.postable.expire_at);
            }
        }
        else {
            _this.type = NeighbourhoodAidType.SEARCH;
            _this.hasExpireAt = true;
        }
        return _this;
    }
    NeighbourhoodAidDto.prototype.toRestModel = function () {
        var model = _super.prototype.toRestModel.call(this);
        model.message = this.message;
        model.type = this.type;
        model.asap = this.asap;
        if (this.expireAt) {
            model.expire_at = dateToString(this.expireAt, { resetTime: true });
        }
        return model;
    };
    NeighbourhoodAidDto.prototype.toGqlModel = function (merge) {
        var model = _super.prototype.toGqlModel.call(this, merge);
        model.postable = {
            message: this.message,
            type: this.type,
            asap: this.asap,
            interested: false,
        };
        if (this.expireAt) {
            model.postable.expire_at = dateToString(this.expireAt);
        }
        return deepMerge(model, merge);
    };
    __decorate([
        IsEnum(NeighbourhoodAidType),
        __metadata("design:type", Number)
    ], NeighbourhoodAidDto.prototype, "type", void 0);
    __decorate([
        IsBoolean(),
        IsOptional(),
        __metadata("design:type", Boolean)
    ], NeighbourhoodAidDto.prototype, "asap", void 0);
    __decorate([
        IsDate(),
        ValidateIf(function (v) { return v.hasExpireAt; }),
        __metadata("design:type", Date)
    ], NeighbourhoodAidDto.prototype, "expireAt", void 0);
    __decorate([
        IsBoolean(),
        IsOptional(),
        __metadata("design:type", Boolean)
    ], NeighbourhoodAidDto.prototype, "hasExpireAt", void 0);
    return NeighbourhoodAidDto;
}(PostDto));
export { NeighbourhoodAidDto };
var MarketplacePostDto = /** @class */ (function (_super) {
    __extends(MarketplacePostDto, _super);
    function MarketplacePostDto(post) {
        var _this = _super.call(this, PostableType.MARKETPLACE, post) || this;
        if (post) {
            _this.message = post.postable.message;
            _this.type = post.postable.type;
            _this.priceType = post.postable.price_type;
            _this.price = post.postable.price;
        }
        else {
            _this.postableType = PostableType.MARKETPLACE;
        }
        return _this;
    }
    MarketplacePostDto.prototype.toRestModel = function () {
        var model = _super.prototype.toRestModel.call(this);
        model.message = this.message;
        model.type = this.type;
        model.price_type = this.priceType;
        model.price = this.price;
        return model;
    };
    MarketplacePostDto.prototype.toGqlModel = function (merge) {
        var model = _super.prototype.toGqlModel.call(this, merge);
        model.postable = {
            message: this.message,
            type: this.type,
            price_type: this.priceType,
            price: this.price,
            interested: false,
        };
        return deepMerge(model, merge);
    };
    __decorate([
        IsEnum(MarketplaceType),
        __metadata("design:type", Number)
    ], MarketplacePostDto.prototype, "type", void 0);
    __decorate([
        IsEnum(MarketplacePriceType),
        ValidateIf(function (post) { return post.type === MarketplaceType.OFFER; }),
        __metadata("design:type", Number)
    ], MarketplacePostDto.prototype, "priceType", void 0);
    __decorate([
        IsNumber(),
        ValidateIf(function (post) { return post.priceType === MarketplacePriceType.FIXED_PRICE; }),
        __metadata("design:type", Number)
    ], MarketplacePostDto.prototype, "price", void 0);
    return MarketplacePostDto;
}(PostDto));
export { MarketplacePostDto };
var DocumentPostDto = /** @class */ (function (_super) {
    __extends(DocumentPostDto, _super);
    function DocumentPostDto(post) {
        var _this = _super.call(this, PostableType.DOCUMENT, post) || this;
        if (post) {
            _this.attachmentId = post.postable.attachment.id;
        }
        return _this;
    }
    DocumentPostDto.prototype.toRestModel = function () {
        var model = _super.prototype.toRestModel.call(this);
        model.attachment_id = this.attachmentId;
        return model;
    };
    DocumentPostDto.prototype.setAttachments = function (attachments) {
        this.attachmentId = attachments[0].id;
    };
    DocumentPostDto.prototype.toGqlModel = function (merge) {
        var model = _super.prototype.toGqlModel.call(this, merge);
        if (merge.attachments) {
            model.postable = {
                message: '',
                attachment: merge.attachments[0],
            };
        }
        return deepMerge(model, merge);
    };
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", Number)
    ], DocumentPostDto.prototype, "attachmentId", void 0);
    __decorate([
        IsEmpty(),
        __metadata("design:type", String)
    ], DocumentPostDto.prototype, "message", void 0);
    return DocumentPostDto;
}(PostDto));
export { DocumentPostDto };
var EventPostDto = /** @class */ (function (_super) {
    __extends(EventPostDto, _super);
    function EventPostDto(post) {
        var _this = _super.call(this, PostableType.EVENT, post) || this;
        if (post) {
            _this.location = post.postable.location;
            _this.startDate = stringToDate(post.postable.start_date);
            _this.startTime = timeToUiString(post.postable.start_date);
            _this.platformRoomId = post.postable.platform_room_id;
            _this.endTime = timeToUiString(post.postable.end_date);
            _this.accessStatus = post.postable.access_status;
        }
        else {
            _this.occurance = EventOccurrence.NONE;
            _this.accessStatus = EventAccessStatus.PUBLIC;
            _this.startTime = '00:00';
            _this.endTime = '01:00';
            _this.platformRoomId = 0;
        }
        return _this;
    }
    EventPostDto.prototype.toRestModel = function () {
        var model = _super.prototype.toRestModel.call(this);
        var _a = this.getDates(true), startDate = _a[0], endDate = _a[1];
        model.message = this.message;
        model.location = this.location;
        model.start_date = startDate;
        model.end_date = endDate;
        model.access_status = this.accessStatus;
        model.occurrence = this.occurance;
        model.from_date = dateToString(this.startDate);
        model.to_date = dateToString(this.toDate);
        model.platform_room_id = this.platformRoomId;
        return model;
    };
    EventPostDto.prototype.toGqlModel = function (merge) {
        var model = _super.prototype.toGqlModel.call(this, merge);
        var _a = this.getDates(), start_date = _a[0], end_date = _a[1];
        var platform_room_id = 0;
        model.postable = {
            message: this.message,
            location: this.location,
            access_status: this.accessStatus,
            start_date: start_date,
            end_date: end_date,
            platform_room_id: platform_room_id,
            response_status: EventResponseStatus.NONE,
            event_invitations: { data: [] },
            event_applications: { data: [] },
            event_responses: { data: [] },
        };
        return deepMerge(model, merge);
    };
    EventPostDto.prototype.getDates = function (fixDates) {
        if (fixDates === void 0) { fixDates = false; }
        var startDate = new Date();
        var startTimeParts = parseTime(this.startTime);
        startDate.setTime(this.startDate.getTime());
        startDate.setHours(startTimeParts[0]);
        startDate.setMinutes(startTimeParts[1]);
        startDate.setSeconds(0);
        startDate.setMilliseconds(0);
        var endDate = new Date();
        var endTimeParts = parseTime(this.endTime);
        endDate.setTime(this.startDate.getTime());
        endDate.setHours(endTimeParts[0]);
        endDate.setMinutes(endTimeParts[1]);
        endDate.setSeconds(0);
        endDate.setMilliseconds(0);
        // if endTime is smaller, take endDate to the next day
        if (fixDates && compareTimes(this.startTime, this.endTime) === 1) {
            endDate.setDate(startDate.getDate() + 1);
        }
        return [dateToString(startDate), dateToString(endDate)];
    };
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", String)
    ], EventPostDto.prototype, "location", void 0);
    __decorate([
        IsDate(),
        __metadata("design:type", Date)
    ], EventPostDto.prototype, "startDate", void 0);
    __decorate([
        IsDate(),
        IsOptional(),
        __metadata("design:type", Date)
    ], EventPostDto.prototype, "endDate", void 0);
    __decorate([
        IsDate(),
        IsOptional(),
        __metadata("design:type", Date)
    ], EventPostDto.prototype, "toDate", void 0);
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", String)
    ], EventPostDto.prototype, "startTime", void 0);
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", String)
    ], EventPostDto.prototype, "endTime", void 0);
    __decorate([
        IsEnum(EventAccessStatus),
        __metadata("design:type", Number)
    ], EventPostDto.prototype, "accessStatus", void 0);
    __decorate([
        IsOptional(),
        IsEnum(EventOccurrence),
        __metadata("design:type", String)
    ], EventPostDto.prototype, "occurance", void 0);
    __decorate([
        IsOptional(),
        __metadata("design:type", Number)
    ], EventPostDto.prototype, "platformRoomId", void 0);
    return EventPostDto;
}(PostDto));
export { EventPostDto };
var LikeDto = /** @class */ (function () {
    function LikeDto(userId, likeableId, likeableType) {
        this.userId = userId;
        this.likeableId = likeableId;
        this.likeableType = likeableType;
    }
    LikeDto.create = function (userId, likeableId, likeableType) {
        if (likeableType === void 0) { likeableType = 'post'; }
        return new LikeDto(userId, likeableId, likeableType);
    };
    LikeDto.prototype.toModel = function () {
        return {
            user_id: this.userId,
            likeable_id: this.likeableId,
            likeable_type: this.likeableType,
        };
    };
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", Number)
    ], LikeDto.prototype, "userId", void 0);
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", Number)
    ], LikeDto.prototype, "likeableId", void 0);
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", String)
    ], LikeDto.prototype, "likeableType", void 0);
    return LikeDto;
}());
export { LikeDto };
